import { DEFAULT_VERTICALS } from "Shared/consts";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

const verticalStorage = createJSONStorage<number[]>(() => sessionStorage);

export const selectedVerticalsAtom = atomWithStorage<number[]>(
	"selectedVerticals",
	DEFAULT_VERTICALS.split(",").map(Number),
	verticalStorage,
);
